import React, { useState } from 'react';
import moment from 'moment';

import { config } from '../../../config/index';

import {
  toWeekInt,
  toWeekString,
  toWeekEndDate,
} from '../../../helpers/moment';

import Modal from 'react-modal';

import UploadFile from '../../../components/Input/UploadFile';

const { API_URL } = config;

const PickRate = ({
  activeClient,
  activeSite,
  activeDate,
  activeWeek,
  schedules,
}) => {
  const padding = 90; // adjust this to your needs
  let height = 375 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    height: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '50%',
    maxWidth: '50rem',
  };

  const [showModal, setShowModal] = useState(false);
  const [template] = useState(true);
  const [modalResponseError, setModalResponseError] = useState('');

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setModalResponseError('');
    setShowModal(false);
  };

  return (
    <React.Fragment>
      {activeClient && activeWeek.startDate && activeSite && (
        <React.Fragment>
          <div
            className="adjust-card-shadow mb-4 px-4 d-flex flex-row justify-content-between align-items-center"
            style={{
              height: '120px',
              borderLeft: ' 10px solid #e4721b',
              marginRight: '1rem',
            }}
          >
            <div className="d-flex flex-column" style={{ width: '70%' }}>
              <h6 className="adjust-upload-title">Pick Rate</h6>
              <p className="text-muted adjust-upload-description">
                You will be able to upload the pick rates once the week has
                ended.
              </p>
            </div>
            {/* <button type="button" disabled={(moment().day() !== 0) ? true : false} onClick={handleOpenModal} className="btn btn-outline-brand" style={{width: 150}}>Upload</button> */}
            <button
              type="button"
              disabled={false}
              onClick={handleOpenModal}
              className="btn btn-outline-brand adjust-btn-shadow px-3"
            >
              Upload
            </button>
          </div>
          <Modal
            ariaHideApp={false}
            isOpen={showModal}
            style={{
              overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
              content: style,
            }}
          >
            <h5>
              Upload Pick rate for Week{' '}
              {toWeekInt(activeWeek.startDate, activeClient.start_day)},{' '}
              {toWeekString(activeWeek.endDate, activeClient.start_day)}
            </h5>
            <small>
              A final performance score for each employee on this week will be
              calculated once pick rates are uploaded.
            </small>

            {modalResponseError && (
              <div>
                <label
                  style={{
                    color: '#f83232',
                    paddingTop: 11,
                    fontWeight: 700,
                  }}
                >
                  Results:
                </label>
                <p className="mb-4 ms-2" style={{ color: '#f84949' }}>
                  {modalResponseError}
                </p>
              </div>
            )}

            <p className="text-muted">Drag and drop your file here</p>

            <UploadFile
              url={`${API_URL}/site/${activeSite.id}/upload/pick_rate`}
              handleCloseModal={handleCloseModal}
              template={'templates/pick_rates_template.csv'}
              setModalResponseError={setModalResponseError}
            />
          </Modal>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default PickRate;
